__webpack_require__.p = "/frontend/paygames/entrance/";